module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"add_date":"Add date","restricted_dates":"Restricted dates","restricted_dates_text":"Prevent customers from selecting pickup and delivery on specific dates of the year."},"id":{"add_date":"Tambah tanggal","restricted_dates":"Batasan tanggal","restricted_dates_text":"Pelanggan tidak bisa memilih pengambilan dan pengiriman pada tanggal tertentu dalam setahun"}}')
  delete Component.options._Ctor
}
